import { Injectable } from "@angular/core";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class ErrorService {
  constructor(private readonly httpHelperService: HttpHelperService) {}
}
